<template>
  <div class="navbar-mobile">
    <div style="position: relative">
<!--      <div class="hamburger">-->
<!--        <div class="hamburger-icon" :class="{open: open}" @click="open = !open">-->
<!--          <template v-for="(item, index) in 4">-->
<!--            <span/>-->
<!--          </template>-->
<!--        </div>-->
<!--      </div>-->

      <img src="../assets/img/logo.png" alt="logomob">
    </div>

    <transition name="fade">
      <div class="navbar-mobile-opened" v-if="open">
        <div class=" elems d-flex justify-content-center">
        <transition name="fade" mode="out-in">

          <div v-if="language === 'HU'" key="menu-hu">
            <p class="font__futura-medium" @click="scroll('block-about-mobile')" >RÓLUNK</p>
            <p class="font__futura-medium" @click="scroll('block-soundlab-mobile')" >SOUNDLAB</p>
            <p class="font__futura-medium" @click="scroll('block-video-mobile')" >MÉDIA</p>
            <p class="font__futura-medium" @click="scroll('block-contact-mobile')">KAPCSOLAT</p>
            <p class="font__futura-medium" @click="redirectToShop">SHOP</p>
          </div>

          <div v-if="language === 'EN'" key="menu-en" >
            <p class="font__futura-medium" @click="scroll('block-about-mobile')">ABOUT</p>
            <p class="font__futura-medium" @click="scroll('block-soundlab-mobile')">SOUNDLAB</p>
            <p class="font__futura-medium" @click="scroll('block-video-mobile')">MEDIA</p>
            <p class="font__futura-medium" @click="scroll('block-contact-mobile')">CONTACT</p>
            <p class="font__futura-medium" @click="redirectToShop">SHOP</p>
          </div>

        </transition>
        </div>
<!--        <div class="left">-->
<!--        <div class="navigation__language">-->
<!--          <p class="font__futura-book"-->
<!--             @click="changeLanguage('EN')"-->
<!--             :class="{'navigation__language-active': language === 'EN',-->
<!--                      'navigation__language-inactive': language === 'HU'}">EN</p>-->
<!--          <p class="line">|</p>-->
<!--          <p class="font__futura-book"-->
<!--             @click="changeLanguage('HU')"-->
<!--             :class="{'navigation__language-active': language === 'HU',-->
<!--                      'navigation__language-inactive': language === 'EN'}">HU</p>-->

<!--        </div>-->
<!--          </div>-->
      </div>
    </transition>


  </div>
</template>

<script>
export default {
  name: "NavbarMobile",
  computed: {
    language: function () {
      return this.$store.getters.language;
    }
  },
  methods:{
    changeLanguage(language) {
      this.$store.commit('setLanguage', language);
      // this.$store.commit('setScrollPercentage', 0);
    },
      redirectToShop(){
          window.open('https://shop.asanbudapest.com/ruhazat', '_blank');
      },
    scroll(id) {
      this.open = false;
      this.active = id;
      const element = document.getElementById(id);
      const offset = 100;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  },
  data: function () {
    return {
      open: true
    }
  },
}
</script>

<style scoped>
.siteava{
  font-size: 10pt !important;
  margin-top: 20px;
}
iframe{
  width: 100%;
  height: 30vh;
}
.left{
  margin-left: 22vw;
}
.navigation__language{
  display: flex;
  margin-top: 10vh;
}

.navigation__language p{
  font-size: 4vw;
  letter-spacing: 2pt;
  margin-right: 3vw;
}
.navigation__language-active {
  color: white;
}

.navigation__language-inactive {
  color: #aebfbd;
}
.navigation__language .line{
  pointer-events: none;
  color: #aebfbd;

}
.navbar-mobile-opened{
  position: absolute;
  top: 80px;
  height: 100vh;
  background-color: var(--asan-dark-grey);
  width: 100%;
  z-index: 10;
  padding-top: 7vh;
}

.navbar-mobile-opened .elems p{
  font-size: 5vw;
  margin-bottom: 5.5vh;
  letter-spacing: 4pt;
  color: white;
}
img{
  width: 160px;
  position: absolute;
  right: 22px;
  top: 30px;
}
.navbar-mobile{
  height: 80px;
  width: 100%;
  background-color: black;
  position: fixed;
  top: 0;
  left: 0;
}

.hamburger {
  position: absolute;
  left: 22px;
  top: 32px;
  z-index: 2;
}

.hamburger-icon {
  width: 22px;
  height: 5px;
  /*position: relative;*/
  /*margin: 32px auto;*/
  -webkit-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .5s ease-in-out;
  -o-transition: .5s ease-in-out;
  transition: .5s ease-in-out;
  cursor: pointer;

}


.hamburger-icon span {
  background: white;
  display: block;
  position: absolute;
  height: 3px;
  width: 100%;
  border-radius: 5px;
  opacity: 1;
  left: 0;
  -webkit-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .25s ease-in-out;
  -o-transition: .25s ease-in-out;
  transition: .25s ease-in-out;
}

.hamburger-icon span:nth-child(1) {
  top: 0px;
}

.hamburger-icon span:nth-child(2), .hamburger-icon span:nth-child(3) {
  top: 6px;
}

.hamburger-icon span:nth-child(4) {
  top: 12px;
}

.hamburger-icon.open span:nth-child(1) {
  top: 18px;
  width: 0%;
  left: 50%;
}

.hamburger-icon.open span:nth-child(2) {
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.hamburger-icon.open span:nth-child(3) {
  -webkit-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

.hamburger-icon.open span:nth-child(4) {
  top: 18px;
  width: 0%;
  left: 50%;
}
</style>